const DNI_REGEX = /^(\d{8})([A-Z])$/;
const CIF_REGEX = /^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/;
const NIE_REGEX = /^[XYZ]\d{7,8}[A-Z]$/;
const PASSPORT_REGEX = /^[A-Z0-9]{6,9}$/i;
const PASSPORT_REGEX2 = /^[A-Z]{2}[0-9]{7}$/;

export const ValidateSpanishID = function(str) {
    if(str == null){
        return {};
    }  
    // Ensure upcase and remove whitespace
    str = str.toUpperCase().replace(/\s/, '');

    var valid = false;
    var type = spainIdType(str);
    console.log(type)
    switch (type) {
        case 'dni':
            valid = validDNI(str);
            break;
        case 'nie':
            valid = validNIE(str);
            break;
        case 'cif':
            valid = validCIF(str);
            break;
        case 'passport2':
            valid = true;
            break;
        case 'passport':
            valid = validPassport(str);
            break;

    }

    return {
        type: type,
        valid: valid
    };
};

export const spainIdType = function(str) {

    if (str.match(DNI_REGEX)){
        return 'dni';
    }
    if (str.match(CIF_REGEX)){
        return 'cif';
    }
    if (str.match(NIE_REGEX)){
        return 'nie';
    }
    if (str.match(PASSPORT_REGEX2)){
        return 'passport2';
    }
    if (str.match(PASSPORT_REGEX)){
        return 'passport';
    }
};

export const validDNI = function(dni) {
    var dni_letters = "TRWAGMYFPDXBNJZSQVHLCKE";
    var letter = dni_letters.charAt( parseInt( dni, 10 ) % 23 );

    return letter == dni.charAt(8);
};

export const validNIE = function(nie) {
    // Change the initial letter for the corresponding number and validate as DNI
    var nie_prefix = nie.charAt(0);

    switch (nie_prefix) {
        case 'X': nie_prefix = 0; break;
        case 'Y': nie_prefix = 1; break;
        case 'Z': nie_prefix = 2; break;
    }

    return validDNI(nie_prefix + nie.substr(1));
};

export const validCIF = function(cif) {

    if (!cif || cif.length !== 9) {
        return false;
    }

    var letters = ['J', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
    var digits = cif.substr(1, cif.length - 2);
    var letter = cif.substr(0, 1);
    var control = cif.substr(cif.length - 1);
    var sum = 0;
    var i;
    var digit;

    if (!letter.match(/[A-Z]/)) {
        return false;
    }

    for (i = 0; i < digits.length; ++i) {
        digit = parseInt(digits[i]);

        if (isNaN(digit)) {
            return false;
        }

        if (i % 2 === 0) {
            digit *= 2;
            if (digit > 9) {
                digit = parseInt(digit / 10) + (digit % 10);
            }

            sum += digit;
        } else {
            sum += digit;
        }
    }

    sum %= 10;
    if (sum !== 0) {
        digit = 10 - sum;
    } else {
        digit = sum;
    }

    if (letter.match(/[ABEH]/)) {
        return String(digit) === control;
    }
    if (letter.match(/[NPQRSW]/)) {
        return letters[digit] === control;
    }

    return String(digit) === control || letters[digit] === control;
}

/*export const validPassport = function(passport){ 
  return PASSPORT_REGEX.test(passport);
}*/

export const validPassport = function(fullPassport) {
    // 1. Limpieza básica y validación de longitud mínima
    const cleanData = fullPassport.trim().toUpperCase();
    if (cleanData.length < 2) return false;

    // 2. Separar el cuerpo del supuesto dígito verificador (el último carácter)
    const body = cleanData.slice(0, -1);
    const checkDigitProvided = cleanData.slice(-1);

    // 3. El dígito verificador SIEMPRE debe ser un número (0-9)
    if (!/^\d$/.test(checkDigitProvided)) {
        console.error("Error: El último carácter debe ser un número (dígito de control).");
        return false;
    }

    // 4. Calcular el dígito que DEBERÍA tener según el algoritmo 7-3-1
    const weights = [7, 3, 1];
    let sum = 0;

    for (let i = 0; i < body.length; i++) {
        const char = body[i];
        let value;

        if (/[0-9]/.test(char)) {
            value = parseInt(char);
        } else if (/[A-Z]/.test(char)) {
            value = char.charCodeAt(0) - 55; // A=10, B=11...
        } else if (char === '<') {
            value = 0;
        } else {
            return false; // Carácter inválido en el cuerpo
        }

        sum += value * weights[i % 3];
    }

    const calculatedDigit = sum % 10;

    // 5. Comparar el calculado con el provisto
    return calculatedDigit === parseInt(checkDigitProvided);
}